module.exports = __webpack_public_path__ + "static/babyaccmain-1c96c5f9dbbe629bf55b450f807f7f5f.jpeg";